(function () {

  console.log("Colors");

  const productPage = document.querySelector('product-page');
  const color = productPage?.dataset.color;

  const colors_array = [
    "Amarillo Pálido",
    "Dorado",
    "Ámbar Claro",
    "Ámbar",
    "Ámbar Intenso",
    "Marrón Claro",
    "Marrón Rojizo",
    "Marrón Oscuro",
    "Marrón Muy Oscuro",
    "Negro"
  ];

  const index = colors_array.indexOf(color);

  if (index === -1) return;

  const segments = document.querySelectorAll(
    '.product-attribute-meter_segments .product-attribute-meter__segment'
  );

  const segment = segments[index];

  if (segment) {
    // lo que necesites hacer
    segment.classList.add('active');
  }

})();
